import * as React from 'react'

import { Box, ProgressBar, Text } from '@factorialco/deprecated-design-system'

export const CompletionBarWithTitle: React.FC<{
  title?: string
  total: number
  completed: number
}> = ({ title, total, completed }) => {
  return (
    <Box gap="s12">
      {title && (
        <Text size="300" weight="semibold" color="grey1000">
          {title}
        </Text>
      )}
      <ProgressBar showLabel total={total} amount={completed} progressColor="viridian1200" />
    </Box>
  )
}
